import { render, staticRenderFns } from "./DashboardCSI.vue?vue&type=template&id=cf643b72&"
import script from "./DashboardCSI.vue?vue&type=script&lang=js&"
export * from "./DashboardCSI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCSI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports